import { environment } from '../../../environments/environment';


import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit
} from '@angular/core';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { instiLoading } from '../../insti/instiLoading.module';
import { AppConfig } from '../../app.config';
import { FullService } from './full.service';
/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: ['full.component.css'],
})
export class FullComponent implements OnDestroy, AfterViewInit {

  @ViewChild('snav', {static: false}) sidenav:any;

  env = environment;
  cor_env = 'primary';
  titulo_env = '';
  mobileQuery: MediaQueryList;
  dir = 'ltr';
  green: boolean;
  blue: boolean;
  dark: boolean;
  minisidebar: boolean;
  boxed: boolean;
  danger: boolean;
  showHide: boolean;
  sidebarOpened;
  open:boolean; 
  is_loading: boolean=true;
  loadObj: instiLoading;
  chg_detect:ChangeDetectorRef;

  empresa_selecionada:number = null;
  empresas: any[] = [];

  onChangeType(event){    
    console.log('event', event);   
  }



  public config: PerfectScrollbarConfigInterface = {};
  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    protected service: FullService
    //public menuItems: MenuItems
    //public menuItems: InstiMenu
    
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => {
      changeDetectorRef.detectChanges();
    }
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.green = true;
    this.chg_detect=changeDetectorRef;
    this.loadObj=new instiLoading();
    this.setIsLoading(true);
    
    /* Uso URL dinamica */
    // if(this.env.base_url_api.indexOf('homologacao') != -1){
    //   this.cor_env = 'warn';
    //   this.titulo_env = 'homologação';
    //   this.danger = true;
    //   this.blue = this.green = false;
    // }
    // else if(this.env.base_url_api.indexOf('producao') != -1){
    //   this.cor_env = 'primary';
    //   this.titulo_env = '';
    //   this.green = true;
    //   this.blue = this.danger = false;
    // }
    // else{
    //   this.cor_env = 'primary';
    //   this.titulo_env = '';
    //   this.green = true;
    //   this.blue = this.danger = false;
    // }
    if(AppConfig.settings.url.baseUrl.indexOf('homologacao') != -1){
      this.cor_env = 'warn';
      this.titulo_env = 'homologação';
      this.danger = true;
      this.blue = this.green = false;
    }
    else if(AppConfig.settings.url.baseUrl.indexOf('producao') != -1){
      this.cor_env = 'primary';
      this.titulo_env = '';
      this.green = true;
      this.blue = this.danger = false;
    }
    else{
      this.cor_env = 'primary';
      this.titulo_env = '';
      this.green = true;
      this.blue = this.danger = false;
    }
    
    //this.menuItems.load(environment.main_menu_id);
    
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit() {

    this.chg_detect.detectChanges();

    // This is for the topbar search
    (<any>$('.srh-btn, .cl-srh-btn')).on('click', function() {
      (<any>$('.app-search')).toggle(200);
    });
    // This is for the megamenu
    
    this.loadEmpresas();
    this.empresa_selecionada = parseInt(localStorage.getItem('empresa_selecionada'));
    console.log('empresa_selecionada', this.empresa_selecionada);
    

    document.body.style.zoom = "100%";
  }

  ngAfterContentChecked() {

    this.chg_detect.detectChanges();

  }

  loadEmpresas(){
    this.service.doHttp('empresa/listar/usuario', 'get', (res)=>{
      this.empresas = res;
      if(!this.empresa_selecionada){
        for (const empresa of this.empresas) {
          if(empresa.empresa_principal == 1){
            this.empresa_selecionada = empresa.id;
            localStorage.setItem('empresa_selecionada', this.empresa_selecionada.toString());
          }
        }
      }
    })

  }

  toggleSidenav()
  {
    this.sidenav.toggle();
  }

  getIsLoading(){
    let a=this.loadObj.getIsLoading();
    this.is_loading=a;    
    return this.is_loading; 
  }
  setIsLoading(value: boolean){ 
    this.is_loading=value;    
    this.loadObj.setIsLoading(value);
    //this.is_loading.emit(this.loadObj.getIsLoading());     
     return this;
 }

  onActivate(componentReference) {
    if(!componentReference.hasOwnProperty('is_loading')){
      return this;  
    }
    let instance= this;
    componentReference.is_loading.subscribe((data) => {
        instance.setIsLoading(data);     
    });  
  }

  onChangeEmpresa(){
    localStorage.setItem('empresa_selecionada', this.empresa_selecionada.toString());
    window.location.reload();
  }
  
  // Mini sidebar
  // gotoHome(){
  //   this.insti_route.getRoutObj().navigate([this.service.getHomeUrl(true)]);
  // }

}

   
